import { render, staticRenderFns } from "./PanelItem.vue?vue&type=template&id=21c532fe"
import script from "./PanelItem.vue?vue&type=script&lang=js"
export * from "./PanelItem.vue?vue&type=script&lang=js"
import style0 from "./PanelItem.vue?vue&type=style&index=0&id=21c532fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports